import { createContext, useContext } from 'react';

export type MailingViberSmsCascadeContextValue = {
  /** Первый узел канала SMS/Viber на линейном пути (дайад без Email). */
  firstChannelNodeId: string | null;
  viberSmsCascadeLinked: boolean;
  setViberSmsCascadeLinked: (v: boolean) => void;
  readOnly: boolean;
};

export const MailingViberSmsCascadeContext = createContext<MailingViberSmsCascadeContextValue | null>(null);

export function useMailingViberSmsCascadeContext(): MailingViberSmsCascadeContextValue | null {
  return useContext(MailingViberSmsCascadeContext);
}
